export type FiltroDaConta = {
  readonly busca: string;
  readonly papel: string;
  readonly situacao: string;
};

export const FILTRO_DA_CONTA_VAZIO: FiltroDaConta = { busca: "", papel: "", situacao: "" };

const SITUACAO = {
  ativo: (item: { ativo: boolean; senhaDefinida: boolean }) => item.ativo && item.senhaDefinida,
  convite: (item: { ativo: boolean; senhaDefinida: boolean }) => item.ativo && !item.senhaDefinida,
  desativado: (item: { ativo: boolean }) => !item.ativo,
} as const;

export function normalizarTexto(texto: string): string {
  return texto
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .toLowerCase();
}

export function coincideComFiltroDaConta(
  item: { nome: string; email: string; papel: string; ativo: boolean; senhaDefinida: boolean },
  filtro: FiltroDaConta,
): boolean {
  const termo = normalizarTexto(filtro.busca.trim());
  if (termo.length > 0) {
    const noNome = normalizarTexto(item.nome).includes(termo);
    const noEmail = item.email.toLowerCase().includes(filtro.busca.trim().toLowerCase());
    if (!noNome && !noEmail) return false;
  }
  if (filtro.papel !== "" && item.papel !== filtro.papel) return false;
  if (filtro.situacao === "ativo") return SITUACAO.ativo(item);
  if (filtro.situacao === "convite") return SITUACAO.convite(item);
  if (filtro.situacao === "desativado") return SITUACAO.desativado(item);
  return true;
}

export function filtroDaContaAtivo(filtro: FiltroDaConta): boolean {
  return filtro.busca.trim() !== "" || filtro.papel !== "" || filtro.situacao !== "";
}
